// Set the key-value pairs for the different languages you want to support.
export default {

    aria: {
        image: {
            card: 'Aufgaben Karte',
        },
        text: {
            cardadd: 'Aufgabe hinzufügen',
        },
    },

    game: {
        title: 'InA.Coach Pausenspiel',
        marked: '%{marked} Regenbogen von %{hidden} markiert',
        score: 'Punkte: %{score} von %{hidden} und %{closed} Felder zu prüfen',
        final: 'Punkte: %{score} von %{hidden}: %{rate}%',
        start: 'Start',
        restart: 'Neu',
        help: 'Das Ziel dieses Spiels ist es, die schwarzen Felder ⬛️ freizulegen (mit Touch) und möglichst viele der versteckten Regenbogen 🌈 zu erraten und zu markieren (mit Long-Touch).\nWenn beim Freilegen ein Regenbogen getroffen wird, so taucht eine Regenwolke 🌧 auf - so ein Pech. Ansonsten geben die freigelegten Felder mit den Nummern 1️⃣..8️⃣ einen Hinweis, wie viele Regenbogen in ihrer Nähe sind. Am Ende wird sich zeigen, wie viele Regenbogen richtig markiert wurden.\nPunkte: \n ✦ 🌧 = -1\n ✦ 🌈 richtig = +1\n ✦ 🌈 falsch = -2'
    },

    tutorial: {
        title: 'Tutorial',
        skip: 'Überspringen',
        done: 'Beenden',
        title0: 'Wie funktioniert die InA.Coach App?',
        text0: 'Die InA.Coach App hilft Ihnen, Ihre Aufgaben im Arbeitsalltag zu erledigen. Nutzen Sie dafür vorgefertigte einfache Anleitungen für Arbeitsabläufe oder erstellen Sie im Handumdrehen eigene Anleitungen.\n\nFür eine kurze Einführung wischen Sie nach links.',
        title1: 'Einstellungen',
        text1: 'Wenn Sie in der farbigen Kopfzeile der App von links nach rechts wischen, erreichen Sie das Einstellungsmenü der App. Sind Sie auf dem Home-Bildschirm, können Sie auch das Profilbild anklicken. Tippen Sie außerhalb des geöffneten Menüs, schließt sich das Menü wieder.',
        title2: 'Aktualisieren',
        text2: 'Um Aufgaben vom Server zu aktualisieren, wischen Sie in der «Aufgabenliste» von oben nach unten.\nFür diesen Datenaustausch muss Ihr Smartphone mit dem Internet verbunden sein.',
        title3: 'Verschieben',
        text3: 'Möchten Sie beim Erstellen einer neuen Aufgabe die Reihenfolge der Schritte ändern, drücken Sie einfach lange auf ein Listenelement und schieben es an die gewünschte Stelle.',
        title4: 'Aufgabe anlegen und löschen',
        text4: 'Jede Aufgabe hat einen Titel und eine kurze Beschreibung und enthält beliebig viele, jedoch mindestens einen Aufgabenschritt.\nSie können Aufgaben oder Schritte löschen, indem Sie auf dem Element, das Sie löschen möchten, von rechts nach ganz links wischen.',
        title5: 'Kontakte / Kanäle',
        text5: 'Im Seitenmenü finden Sie den Menüpunkt «Kontakte». Dort sehen Sie alle Kontakte, die mit Ihnen verknüpft sind.\n«Kanäle» bietet die Möglichkeit, Aufgaben mit mehreren Kontakten gleichzeitig zu teilen. Die Personen selbst wissen dabei nicht, dass sie einem Kanal zugeordnet sind.',
        title6: 'Aufgaben planen',
        text6: 'Planen Sie Aufgaben für sich selbst ein, indem Sie im Planer den «Aufgabe einplanen» Button drücken. Im folgenden PopUp wählen Sie eine Aufgabe aus, legen anschließend das Datum fest und bei Bedarf eine Startzeit und ein Wiederholungsmuster. Bestätigen Sie Ihre Planung zum Schluss mit «Fertig».',
        title7: 'Aufgaben teilen',
        text7: 'Aufgaben, die Sie selbst erstellt haben, können Sie mit Ihren Kontakten und Kanälen teilen. Das bedeutet, dass die Empfänger der Aufgabe, die Aufgabe nur durchführen können. Sie können die Aufgabe weder bearbeiten noch löschen. Geteilte Aufgaben können Sie auf demselben Weg jederzeit wieder von den Empfängern entfernen.',
        title8: 'Kopie senden',
        text8: 'Alternativ ist es möglich, Kopien von Aufgaben an Kontakte und Kanäle zu senden. Diese können von den Empfängern bearbeitet, erneut geteilt und auch gelöscht werden. Sie erhalten keine Informationen über den weiteren Gebrauch dieser Kopien.',
    },

    homescreen: {
        greetMorning: 'Guten Morgen',
        greetDay: 'Guten Tag',
        greetEvening: 'Guten Abend',
        greetNight: 'Gute Nacht',
        infoActiveInA: 'Hallo, ich bin InA!\n',
        infoActive: 'Schön, dass Sie da sind! Sie haben aktuell noch keine angefangenen Aufgaben. Legen Sie los, indem Sie in der Aufgabenliste eine Aufgabe starten.',
        infoPlanned: 'Sie haben heute noch keine Aufgabe geplant. Starten Sie, indem Sie eine Aufgabe im Planer hinzufügen.',
        navActive: 'Angefangen',
        navPlanned: 'Heute',
        clock: 'Uhr'
    },

    sideNavigationDrawer: {
        MainStack: 'Hauptbildschirm',
        accountSettings: 'Account',
        appSettings: 'App Einstellungen',
        contactManagement: 'Kontakte',
        languageSettings: 'Sprache & Ansprache',
        notificationSettings: 'Benachrichtigungen',
        colorSettings: 'Farbeinstellungen & Kontrast',
        legal: 'Rechtliche Hinweise',
        help: 'Hilfe',
        info: 'Über InA.Coach',
        admin: 'Administration',
        myQRCode: 'Mein Kontakt QR-Code',
        logout: 'Abmelden',
    },

    moreOptionsMenu: {
        report: 'Melden',
        refresh: 'Aktualisieren',
        trash: 'Papierkorb',
        share: 'Aufgabe teilen',
        publicshare: 'Aufgabe öffentlich teilen',
        copy: 'Kopie senden',
        plan: 'Aufgabe planen',
        duplicate: 'Aufgabe duplizieren',
        pin: 'Anpinnen',
        unpin: 'Pin lösen',
        settings: 'Einstellungen',
    },

    contactManagement: {
        title: 'Kontakte',
        contactRequest: 'Anfrage',
        requestFrom: 'Von (%{num})',
        requestTo: 'An (%{num})',
        request: 'Anfrage vom %{date}',
        accept: 'Annehmen',
        deny: 'Ablehnen',
        cancel: 'Anfrage löschen',
        contacts: 'Kontakte (%{num})',
        channels: 'Kanäle (%{num})',
        addChannel: 'Neuer Kanal',
        addContact: 'Neuer Kontakt',
        norequests: 'Sie haben gerade keine Kontaktanfragen.',
        nocontacts: 'Sie haben noch keine Kontakte erstellt.',
        nochannels: 'Sie haben noch keine Kanäle angelegt.',
    },

    contact: {
        title: 'Kontakt',
        contacts: 'Kontakte',
        contactsN: 'Kontakte (%{num})',
        alias: 'Alias',
        update: 'Bearbeiten',
        preferredName: 'Wunschname',
        sharedWorkflows: 'Geteilte Aufgaben',
        workflows: 'Aufgaben',
        channels: 'Kanäle',
        workflowsApp: 'Aufgaben (%{num})',
        workflowsN: 'Aufgabe teilen (%{num}) – nur in der App vorhandene und bereits exportierte Aufgaben',
        channelsN: 'Kanäle (%{num})',
        show: 'Anzeigen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        deleteContact: 'Kontakt löschen',
        deleteContactText: 'Soll der Kontakt «%{user}» gelöscht werden?\nBeim Löschen werden auch alle Aufgaben, die «%{user}» mit Ihnen geteilt hat, aus Ihrer Aufgabenliste und dem Planer gelöscht. Ihre geteilten Aufgaben werden bei «%{user}» aus der Aufgabenliste und dem Planer gelöscht.',
        blockContact: 'Kontakt blockieren',
        planAllowed: 'Darf für mich planen',
        permit: 'Erlaubnis',
        planner: 'Planer',
        planForMe: 'Für mich'
    },

    channel: {
        title: 'Kanal',
        info: 'Empfänger',
        channels: 'Kanäle',
        contacts: 'Empfänger (%{num})',
        numcontacts: '%{num} Empfänger',
        name: 'Name',
        description: 'Beschreibung',
        create: 'Neuer Kanal',
        submit: 'Kanal anlegen',
        missing: 'Kanalname fehlt.',
        update: 'Bearbeiten',
        exit: 'Ohne einen Namen kann der Kanal nicht gespeichert werden. Bitte geben Sie dem Kanal einen Namen.',
        continue: 'OK',
        cancel: 'Verlassen',
        addWorkflowsText: 'In diesem Dialog können Sie Aufgaben teilen. Bitte beachten Sie: Es werden nur Aufgaben angezeigt, die Sie in der App erstellt oder bereits in die App exportiert haben. Exportieren Sie die gewünschten InA.Studio Aufgaben vorab über den Button „Überprüfen" im Aufgaben-Editor, um sie hier sehen zu können.',
        addContactText: 'Kontakte verwalten',
        delete: 'Löschen',
        deleteChannel: 'Kanal löschen',
        deleteChannelText: 'Soll der Kanal «%{user}» gelöscht werden?\nBeim Löschen werden alle über diesen Kanal geteilten Aufgaben bei den Empfängern gelöscht und auch aus den Planern der Empfänger entfernt.',
        sharedWorkflows: 'Geteilte Aufgaben (%{num})',
        show: 'Anzeigen',
        edit: 'Bearbeiten',
        addContact: 'Kontakt hinzufügen',
        addContacts: 'Empfänger auswählen',
        noChannels: 'Kanäle ermöglichen das Teilen von Aufgaben mit mehreren Kontakten. Ihre Kontakte wissen dabei nicht, dass sie einem Kanal zugeordnet sind.'
    },

    addContact: {
        title: 'Neuer Kontakt',
        searchMail: 'Suche nach E-Mail-Adresse',
        scanCode: 'Scan QR-Code',
        or: 'oder',
        emailAddress: 'E-Mail-Adresse',
        text: 'Geben Sie die E-Mail-Adresse des gewünschten Kontakts ein.',
        email: 'E-Mail',
        send: 'Anfrage senden',
        cancel: 'Abbrechen',
        requestSent: 'Anfrage gesendet.',
        requestSentText: 'Ihre Kontaktanfrage wurde erfolgreich gesendet.',
        requestFail: 'Anfrage fehlgeschlagen.',
        requestFailCheckInputs: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.\nHinweis: Die E-Mail-Adresse muss bereits in InA.Coach registriert sein.',
        requestFailText: 'Ein Kontakt mit dieser E-Mail-Adresse «%{user}» wurde nicht gefunden.',
        contactAdd: 'Kontakt hergestellt.',
        contactAddText: 'Der Kontakt «%{user}» wurde zu Ihren Kontakten hinzugefügt.',
        contactFail: 'Anfrage fehlgeschlagen.',
        contactFailText: 'Der Kontakt oder die Aufgabe mit dem QR-Code «%{user}» wurde nicht gefunden.',
        workflowShare: 'Öffentlich geteilt',
        workflowShareText: 'Die von «%{name}» geteilte Aufgabe ist momentan inaktiv. Sie wird zu Ihren Aufgaben hinzugefügt, sobald sie wieder aktiv ist.',
        ok: 'OK',
    },

    printQRCode: {
        title: 'QR-Codes Drucken',
        info: 'Labels',
        titleSetup: 'QR-Code Druck',
        infoSetupOne: 'Hier bearbeiten Sie das Drucklayout des QR-Codes.',
        infoSetup: 'Passen Sie die Einstellungen an Ihr Etikettenpapier an.',
        qrcodes: 'QR-Codes',
        offset: 'Seitenrand [mm]: ',
        label: 'Label Größe [mm]: ',
        gap: 'Label Abstand [mm]: ',
        qr: 'QR-Code [mm]: ',
        font: 'Schrift: ',
        layout: 'Layout: ',
        frame: 'Rahmen: ',
        ina: 'InA Logo: ',
        dist: 'Abstand',
        left: 'Links',
        right: 'Rechts',
        top: 'Oben',
        bottom: 'Unten',
        width: 'Breite',
        height: 'Höhe',
        horizontal: 'Horizontal',
        vertical: 'Vertikal',
        columns: 'Spalten',
        rows: 'Zeilen',
        size: 'Größe',
        count: 'Anzahl',
        start: 'Start',
        scale: 'Skaliert',
        setup: 'Layout bearbeiten',
        testPage: 'Testseite',
        print: 'Drucken',
        share: 'Senden',
        printer: 'Drucker'
    },

    shareQRCode: {
        text: 'Zum Ausdrucken im Browser\nhttps://studio.ina.coach \nöffnen. Dort können Sie sich mit dem Scan des QR-Codes einloggen.',
        scanCode: 'Scan Browser Login',
        titleStart: 'Starter QR-Code',
        title: 'Aufgaben QR-Code',
        ownTasks: 'Eigene Aufgaben',
        publicShare: 'Öffentliche Aufgabe',
        publicUser: 'Geteilt von',
        info: 'Öffentlich geteilt',
        infoNeu: 'Öffentlich teilen',
        button: 'Neue Aufgabe öffentlich teilen',
        startQR: 'Starter Code',
        scanGo: 'Scan & Go',
        scanQR: 'Scan QR-Code',
        genPDF: 'Drucken',
        taskQR: 'Öffentlich geteilte Aufgaben',
        location: 'Ort',
        actProfile: 'Verwendetes Profil',
        publish: 'Veröffentlichen',
        profile: 'Mit persönlichem Profil',
        public: 'Mit öffentlichem Profil',
        publicEdit: 'Öffentliches Profil bearbeiten',
        status: 'Status',
        active: 'Aktiv',
        delete: 'Beenden',
        deleteInfo: 'Veröffentlichung beenden',
        used: '%{num} x in Benutzung',
        sample: 'Muster',
        confirmText: 'Die Aufgabe wurde öffentlich geteilt. Beim Beenden wird die Aufgabe bei den Empfängern gelöscht und aus ihren Planern entfernt.\n\nMöchten Sie die Veröffentlichung trotzdem beenden?',
        hint: 'Für jede Aufgabe, die Sie öffentlich teilen möchten, entscheiden Sie neu, ob Sie dafür Ihr öffentliches oder Ihr persönliches Profil nutzen wollen.\n\nBitte beachten Sie: Wenn Sie hier Ihr persönliches Profil verwenden, können alle Nutzer, die mit Scan & Go den QR-Code scannen, in der Aufgabe Ihr persönliches Profilbild und Ihren Wunschnamen sehen.',
        nothingPubliclyShared: 'Sie haben noch keine Aufgabe via QR-Code öffentlich geteilt. Legen Sie los und bringen Sie so Ihre Aufgaben an die Orte, an denen sie tatsächlich erledigt werden sollen.'
    },

    deletedWorkflows: {
        title: 'Papierkorb',
        online: 'Aufgaben auswählen zum Bearbeiten',
        offline: 'Keine Verbindung: nur Anzeige',
        button: 'Endgültig löschen',
        button2: 'Wiederherstellen',
        info: 'In %{days} Tagen gelöscht'
    },

    shareWorkflow: {
        title: 'Hinweis',
        textTaskUnshare: 'Sie haben bei einem oder mehreren Kontakten den Haken entfernt. Die Aufgabe wird bei diesen Kontakten gelöscht und auch aus ihren Planern entfernt.',
        textChannelUnshare: 'Sie haben bei einer oder mehreren Aufgaben den Haken entfernt. Diese Aufgaben werden bei allen Empfängern dieses Kanals gelöscht und auch aus ihren Planern entfernt.',
        textChannelExclude: 'Sie haben bei einem oder mehreren Empfängern den Haken entfernt. Bei diesen Empfängern werden die über diesen Kanal geteilten Aufgaben gelöscht und auch aus ihren Planern entfernt.',
        textContactUnshare: 'Sie haben bei einer oder mehreren Aufgaben den Haken entfernt. Diese Aufgaben werden bei diesem Kontakt gelöscht und auch aus dem Planer entfernt.',
        textContactExclude : 'Sie haben bei einem oder mehreren Kanälen den Haken entfernt. Dieser Kontakt wird aus diesen Kanälen gelöscht. Damit werden bei diesem Kontakt die über diesen Kanal geteilten Aufgaben gelöscht und auch aus dem Planer entfernt.',
        ok: 'OK',
    },

    helpScreen: {
        supportContact: 'Supportkontakt',
        website: 'Webseite',
        email: 'E-Mail',
        tel: 'Telefon',
        helpText: 'Hilfetext',
        helperText1: 'Sollten Sie Hilfe bei der Nutzung der App benötigen, dann schreiben Sie uns eine E-Mail und erklären Sie uns Ihr Problem.\nDabei erwähnen Sie bitte',
        helperText1Studio: 'Sollten Sie Hilfe bei der Nutzung des Studios benötigen, dann schreiben Sie uns eine E-Mail und erklären Sie uns Ihr Problem.\nDabei erwähnen Sie bitte',
        helperText1User: ' Ihre verknüpfte E-Mail-Adresse',
        helperText1Demo: ', dass Sie den Demo-Modus nutzen',
        helperText2: ' und nennen die Versionsnummer ',
        helperText3: ' der App.\nVielen Dank!',
        helperText3Studio: ' des InA.Studios.\nVielen Dank!',
    },

    appSettings: {
        contact: 'Kontakt',
        telButton: 'Telefonbutton',
        telButtonContact: 'Telefonbutton Kontakt',
        helperText: 'Festnetznummer / Handynummer /...',
        colorContrast: 'Farbe & Kontrast',
        color: 'Farbe',
        listFormat: 'Aufgabenliste',
        view: 'Ansicht',
        images: 'Bilder',
        media: 'Medien',
        crop: 'Quadratische Bilder',
        autoplay: 'Autoplay Video',
        showInA: 'InA anzeigen',
        showSpecials: 'InA Specials aktivieren',
        contrast: 'Kontrast',
        fontSize: 'Schriftgröße',
        notifications: 'Benachrichtigungen',
        calendar: 'Kalendereintrag steht aus',
        workflowStopped: 'Aufgabe unterbrochen',
        misc: 'Sonstiges',
        language: 'Sprache',
        speech: 'Sprachausgabe',
        voice: 'Stimme',
        version: 'Version',
        internal: 'Intern',
        preview: 'Preview',
        stateVersion: 'State Version',
        stateSize: 'State Größe [KB]',
        serverVersion: 'Server',
        saving: 'Speichern',
        cancel: 'Abbrechen',
        commit: 'Commit Hash',
        issue: 'Problem in %{commit} melden',
        task0: 'Wäsche waschen',
        task1: 'Bruschetta machen'
    },

    modalColor: {
        text: 'Hier ändern Sie die Farbe der App.\n(Neustart erforderlich)',
        blue: 'Blau',
        green: 'Grün',
        yellow: 'Gelb',
        orange: 'Orange',
        red: 'Rot',
        contrast: 'Hoher Kontrast'
    },

    modalFormat: {
        text: 'Hier ändern Sie die Ansicht der Aufgabenliste.',
        raster: 'Rasteransicht',
        list: 'Listenansicht',
    },

    modalVoice: {
        text: 'Hier ändern Sie die Stimme der Sprachausgabe.',
        raster: 'Stimme',
        sample: 'Hallo ich bin %{voice}',
        language: 'de-DE',
        voice: 'Stimme %{idx}'
    },

    accountSettings: {
        personal: 'Persönlich',
        public: 'Öffentlich',
        gotoPersonal: 'Persönliches Profil bearbeiten',
        gotoPublic: 'Öffentliches Profil bearbeiten',
        gotoPersonalS: 'Persönliches Profil',
        gotoPublicS: 'Öffentliches Profil',
        preferredName: 'Wunschname',
        email: 'E-Mail',
        changePassword: 'Passwort ändern',
        language: 'Sprache',
        account: 'Account',
        deleteAccount: 'Account löschen',
        hint: 'Hinweis',
        hintPersonal: 'Dieser Wunschname und dieses Profilbild sind zusammen mit Ihrer E-Mail-Adresse für Ihre Kontakte sichtbar, wenn Sie Aufgaben mit ihnen teilen.\nWichtig: Wenn Sie dieses persönliche Profil auch verwenden, um eine Aufgabe über Scan & Go öffentlich zu teilen oder im InA.Studio auf dem Marktplatz zu verschenken, können alle Nutzer diesen Wunschnamen und dieses Profilbild sehen. Nur Ihre E-Mail-Adresse ist ausschließlich für Nutzer sichtbar, die auch in Ihrer Kontaktliste stehen.',
        hintPublic: 'Nutzen Sie Ihr öffentliches Profil, wenn Sie Aufgaben über Scan & Go per QR-Code öffentlich teilen oder auf dem Marktplatz im InA.Studio verschenken möchten und dabei nicht das Profilbild und den Wunschnamen Ihres persönlichen Profils zeigen wollen.'
    },

    modalDeleteAccount: {
        text: "Nach Bestätigung wird dieser Account gelöscht.",
        delete: "Löschen",
        cancel: "Abbrechen",
    },

    workflowsScreen: {
        title: 'Aufgabenliste',
        info0: 'Filter: Alle Aufgaben',
        info1: 'Filter: Eigene Aufgaben',
        info2: 'Filter: Geteilte Aufgaben',
        info3: 'Filter: Scan & Go Aufgaben',
        info4: 'Filter: InA.Studio Aufgaben',
        info5: 'Filter: App Aufgaben',
        buttonSearchFilter: 'Suchen und Filtern',
        filter: 'Filtern',
        delete: 'Aufgabe löschen',
        duplicate: 'Aufgabe duplizieren',
        copy: 'Kopie senden',
        copyTitle: 'Kopie einer Aufgabe senden',
        copyInfo: 'Wählen Sie aus, an wen Sie eine Kopie dieser Aufgabe senden wollen.',
        cancel: 'Abbrechen',
        confirmText: 'Die Aufgabe wurde mit Kontakten geteilt. Beim Löschen wird die Aufgabe auch bei den Empfängern gelöscht. Sie wird außerdem aus den Planern der Empfänger entfernt.\n\nMöchten Sie die Aufgabe trotzdem löschen?',
        confirmDelete: 'Möchten Sie die Aufgabe löschen?',
        confirmPublicText: 'Wenn Sie diese Aufgabe löschen, lässt sie sich nicht aus dem Papierkorb zurückholen. Sollten Sie die Aufgabe doch wieder benötigen, müssen Sie den QR-Code erneut scannen.',
    },

    searchScreen: {
        title: 'Aufgabenliste',
        filterText: 'Aufgabenliste filtern',
        filterCat: 'Kategorien filtern',
        buttonMine: 'Eigene Aufgaben',
        buttonOthers: 'Geteilte Aufgaben',
        buttonAll: 'Alle Aufgaben',
        buttonScanGo: 'Scan & Go Aufgaben',
        buttonStudio: 'InA.Studio Aufgaben',
        buttonApp: 'App Aufgaben',
        search: 'Suchen',
        sort: 'Aufgabenliste sortieren',
        alphabetical: 'Alphabetisch',
        oldest: 'Älteste',
        newest: 'Neueste',
        topVote: 'Beliebteste',
        topLoad: 'Meistgenutzte',
        mine: 'Eigene Aufgaben',
        all: 'Alle Aufgaben'
    },

    workflowInformation: {
        title: 'Informationen',
        alias: 'Alias',
        writeRight: 'Schreibrecht',
        sharedWith: 'Geteilt mit',
        persons: '%{num} Personen',
    },

    showWorkflowScreen: {
        title: 'Aufgabe',
        buttonStartTask: 'Aufgabe starten',
        buttonResumeTask: 'Weitermachen',
        buttonStopTask: 'Abbrechen',
        numberOfSteps: '%{steps} Schritte',
        stepProgress: 'Schritt %{step} von %{maxSteps}',
        deleted: 'Diese Aufgabe steht nicht mehr zur Verfügung.',
        fakeTask: {
            title: 'Titelbeschreibung',
            text: 'Beschreibungstext der Aufgabe',
            stepTitle: 'Titel',
            stepText: 'Beschreibungstext, der über zwei Zeilen gehen kann.'
        }
    },

    showStep: {
        title: 'Schritt',
        extra: 'Zusatzschritt',
        no: 'Nein',
        yes: 'Ja',
        onNo: 'Bei Nein',
        onYes: 'Bei Ja',
        onNoNext: 'Bei Nein: nächster Schritt',
        onYesNext: 'Bei Ja: nächster Schritt',
        startTimer: 'Starten',
        stopTimer: 'Beenden',
        pauseTimer: 'Pausieren',
        continueTimer: 'Fortsetzen',
        nextStep: 'Nächster Schritt',
    },

    showItemScreen: {
        title: 'Element',
        check: 'Gemacht',
        uncheck: 'Nicht gemacht'

    },

    finishedScreen: {
        title: 'Aufgabe beenden',
        info: 'Sie haben "%{title}" erledigt und können die Aufgabe jetzt beenden.'
    },

    taskSettings: {
        title: 'Einstellungen',
        execute: 'Checkboxen und Timer',
        strict: 'Verpflichtend',
        category: 'Kategorie',
        any: 'Alle',
        home: 'Haushalt',
        garden: 'Garten',
        allday: 'Alltag',
        medic: 'Hygiene',
        diy: 'Hobby',
        cook: 'Kochen',
        other: 'Sonstige',
        usage: 'Verwendung',
        donated: 'Frei für alle'
     },

    plannerScreen: {
        title: 'Planer',
        titleFor: 'Planer für %{name}',
        info: 'Aufgaben',
        addWorkflow: 'Aufgabe einplanen',
        placeHolder: 'Geplante Aufgabe',
        plannedOwn: 'Eigene (%{num})',
        plannedFor: 'von mir für %{name} (%{num})',
        plannedBy: 'von anderen für %{name} (%{num})',
        plannedForMe: 'von anderen für mich (%{num})'
    },

    chatScreen: {
        title: 'Chat',
        titleFor: 'Chat mit %{name}',
        info: 'Nachrichten',
        message: 'Nachricht',
        send: 'Senden'
    },

    scheduleWorkflow: {
        title: 'Planer',
        info: 'Aufgabe einplanen',
        choose: 'Aufgabe auswählen',
        details: 'Für mich',
        infoOther: 'Für %{name}',
        settings: 'Einstellungen',
        date: 'Datum',
        workflow: 'Aufgabe',
        time: 'Zeit',
        withoutTime: 'Ohne Zeit',
        startTime: 'Startzeit',
        allDay: 'Ganzer Tag',
        endTime: 'Schlusszeit',
        oclock: '%{time} Uhr',
        schedule: '%{time} Uhr / %{freq}',
        allDaySchedule: 'Ganzer Tag / %{freq}',
        repeat: 'Wiederholen',
        once: 'Einmalig',
        never: 'Niemals',
        daily: 'Täglich',
        weekly: 'Wöchentlich',
        monthly: 'Monatlich',
        yearly: 'Jährlich',
        delete: 'Löschen',
        deletePlan: 'Planung löschen',
        deletePlanText: 'Soll die Planung für «%{task}» gelöscht werden?',
    },

    calendar: {
        title: 'Kalender',
        cancel: 'Abbrechen',
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thu: 'Do',
        fri: 'Fr',
        sat: 'Sa',
        sun: 'So',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
        january: 'Januar',
        february: 'Februar',
        march: 'März',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Dezember',
        selectMonth: 'Wähle einen Monat in ',
        selectYear: 'Wähle ein Jahr',
        dateLanguage: 'de',
    },

    modalTime: {
        enterStartTime: 'Startzeit eingeben',
        enterEndTime: 'Schlusszeit eingeben',
        hour: 'Stunde',
        minute: 'Minute',
        ok: 'OK',
        cancel: 'Abbrechen',
    },

    footer: {
        qrcode: 'Scan & Go',
        list: 'Aufgabenliste',
        calendar: 'Kalender',
        planner: 'Planer',
        filter: 'Filter Liste',
        add: 'Neue Aufgabe',
        blank: 'Under Construction',
        edit: 'Bearbeiten',
        home: 'Home',
        forward: 'Weiter',
        prevStep: 'Vorheriger Schritt',
        nextStep: 'Nächster Schritt',
        newStep: 'Neuer Schritt',
        prevItem: 'Vorheriges Element',
        nextItem: 'Nächstes Element',
        newItem: 'Neues Element',
        back: 'Zurück',
        today: 'Heute',
        backTask: 'Zur Aufgabe',
        backStep: 'Zum Schritt',
        backDecide: 'Zur Entscheidung',
        finish: 'Fertig',
        create: 'Fertig',
        send: 'Senden',
        restart: 'Neustart'
    },

    workflowEdit: {
        infoDescription: 'Erklären Sie die Aufgabe',
        addStep: 'Schritt hinzufügen'
    },

    stepType: {
        title: 'Was für ein Schritt',
        do: 'Machen',
        fetch: 'Checkliste',
        wait: 'Warten',
        decide: 'Entscheiden',
        end: 'Ende'
    },

    stepTypeInformation: {
        title: 'Wie funktioniert der...',
        do: 'Machen Schritt',
        fetch: 'Checklisten Schritt',
        wait: 'Warten Schritt',
        decide: 'Entscheiden Schritt',
        doInfo: 'Dieser Schritt ist wahrscheinlich der am häufigsten verwendete Schritt. Schreiben Sie einfache Anweisungen und gestalten Sie diese mit einem oder mehreren Bildern bunt und motivierend.',
        fetchInfo: 'Mit diesem Schritt erstellen Sie eine einfache Checkliste mit Elementen. Wird die Aufgabe später durchgeführt, können die einzelnen Elemente abgehakt werden.',
        waitInfo: 'Diesen Schritt fügen Sie ein, wenn die Aufgabe Wartezeit erfordert (zum Beispiel die Dauer, die das Ciabatta-Brot im Toaster sein soll). Wird dann in der Aufgabe der Timer gestartet, meldet sich die App, sobald der Timer abgelaufen ist.',
        decideInfo: 'In diesem Schritt fragen Sie nach einem gewünschten Zustand in Form einer Ja-/Nein-Frage (zum Beispiel, ob das Ciabatta-Brot ausreichend geröstet ist). Wählen Sie aus, bei welcher Antwort vorherige Schritte wiederholt werden müssen oder Zusatzschritte gebraucht werden, um den gewünschten Zustand zu erreichen. Dabei wird Wiederholen eingesetzt, wenn bereits erstellte Schritte erneut gemacht werden sollen. Zusatzschritte müssen erstellt werden, wenn bisherige Schritte nicht dazu beitragen, den gewünschten Zustand zu erreichen. \n\nWird die Aufgabe später durchgeführt, kann die gestellte Frage mit «Ja» oder «Nein» beantwortet werden. Dann führt die Antwort entweder zur Wiederholung, zum ersten Zusatzschritt oder zum nächsten regulären Schritt.',
        endDescription: 'Sie haben die Aufgabe erledigt und können sie jetzt beenden.',
    },

    playground: {
        title: 'Playground',
    },

    import: {
        title: 'Importieren',
        info: 'Daten einlesen',
        send: 'Verarbeiten',
        hint: 'Hier können Sie Daten im Text oder JSON Format einfügen',
        cancel: 'Abbrechen',
        description: 'Daten zum Import'
    },

    adminModal: {
        reset: 'Reset',
        camera: 'Kamera',
        photos: 'Mediathek',
        images: 'Ina.Coach Medien',
        cache: 'Medien im Cache',
        clean: 'Alle Medien löschen',
        cleanAll: '%{num} Medien löschen %{size}MB',
        cleanUnused: '%{num} unbenutze Medien löschen',
        setServer: 'Login',
        media: 'Medien',
        playground: 'Playground',
        import: 'Import',
        game: 'Game',
        sentryTest: 'Sentry Test',
        sentryCrash: 'Sentry Crash',
        showState: 'Show',
        tokenLogin: 'Login',
        setOnline: 'Set Online',
        setOffline: 'Set Offline',
        tokenCreate: 'Get Token',
        screenshot: 'Screenshot',
        video: 'Test Video',
        chat: 'Chat',
        print: 'QR-Code-Labels',
        notify: '%{sec} notify %{url}',
        notifyCancel: 'Cancel notify',
        shotsOn: 'Screenshots On',
        shotsOff: 'Screenshots Off',
        settings: 'System Einstellungen',
        previewOn: 'Preview On',
        previewOff: 'Preview Off',
        icons: 'Icons'
    },

    login: {
        login: 'Login',
        login2: 'Anmelden',
        email: 'E-Mail',
        password: 'Passwort',
        scan: 'Scan',
        or: 'oder',
        title: 'QR-Code scannen',
        info: 'InA.Coach QR-Code verwenden',
        resetTitle: 'Passwort vergessen?',
        resetInfo: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um ein neues Passwort anzufordern.',
        sentTitle: 'Eine E-Mail wurde versendet.',
        sentInfo: 'Weitere Anweisungen finden Sie in der E-Mail.',
        demoTitle: 'Demoversion testen',
        demoInfo: 'Testen Sie die Demoversion der App ohne vorherige Registrierung. Einige Funktionen stehen Ihnen hier nicht zur Verfügung!',
        demoRun: 'Los geht\'s',
        resetPW: 'Passwort vergessen?',
        reset: 'Zurücksetzen',
        demoMode: 'Starten Sie hier in der Demoversion ohne Registrierung',
        ok: 'OK',
        cancel: 'Abbrechen',
        logout: 'Abmelden',
        logoutText: 'Wenn Sie sich ausloggen, werden Ihre Einstellungen zurückgesetzt und alle erstellten Aufgaben und lokalen Daten in der App gelöscht.',
        logoutSync: 'Ihre Daten sind alle auf dem Server vorhanden und werden beim Login wieder geladen.',
        logoutNoSync: 'Nicht alle Ihre Daten konnten bisher zum Sever gesendet werden. Wenn Sie nicht wollen, dass diese beim Logout verloren gehen, sollten Sie sich zu einem spätern Zeitpunkt ausloggen.',
        switchText: 'Wenn Sie den Benutzer wechseln, werden Ihre Einstellungen, alle erstellten Aufgaben und lokalen Daten in der App für eine erneute Anmeldung mit demselben Benutzer gesichert.',
        switch: 'Benutzer wechseln',
        loginQRCode: 'QR-Code Login',
        loginQRCodeText: 'Scannen mit der InA.Coach App',
        loginData: 'Anmeldedaten',
        stayLogin: 'Angemeldet bleiben',
    },

    itemInput: {
        title: 'Titel',
        text: 'Beschreibung',
        infoTitle: 'Wie heißt die Aufgabe?',
        infoDescription: 'Erklären Sie die Aufgabe.',
        infoTitleStep: 'Wie heißt der Schritt?',
        infoDescriptionStep: 'Erklären Sie den Schritt.',
        infoFrageStep: 'Stellen Sie eine Ja/Nein Frage.',
        infoTitleItem: 'Wie heißt das Element?',
        infoDescriptionItem: 'Erklären Sie das Element.'
    },

    stepEdit: {
        addItem: 'Element hinzufügen',
        selectTarget: 'Zielschritt auswählen',
        dummyTarget: "Hier gewünschten Zielschritt auswählen",
        dummyRegular: "Nächster regulärer Schritt",
        orText: 'oder',
        switchAnswer: 'Antwort tauschen',
        timerInfo: 'Wartezeit in Stunden:Minuten:Sekunden'
    },

    decisionEdit: {
        title: 'Zielschritt wählen',
        confirmTitle: 'Auswahl treffen',
        confirmRepeat: 'Zu Zusatzschritte wechseln',
        confirmRepeatText: 'Möchten Sie Zusatzschritte erstellen, dann müssen Sie zuvor den ausgewählten Schritt bei «Wiederholen» abwählen.',
        confirmExtra: 'Zu Wiederholen wechseln',
        confirmExtraText: 'Möchten Sie vorherige Schritte wiederholen, dann müssen Sie zuvor Ihre erstellten Zusatzschritte löschen.',
        confirmSkip: 'Verstanden. Nie wieder anzeigen.',
        confirmButton: 'OK',

        repeat: 'Wiederholen',
        extra: 'Zusatzschritte',
        addExtra: 'Neuer Zusatzschritt'
    },

    mediaManager: {
        savedImages: 'Gesicherte Bilder',
        cachedImages: 'Cached Bilder',
        imageLoadTitle: 'Bild laden',
        printedPDFs: 'Printed PDFs',
        printed: 'Printed'
    },

    mediaSelector: {
        photosPermission: 'Ohne Zugriff auf die Medienbibliothek können keine eigenen Aufgaben mit Bildern erstellt werden.',
        cameraPermission: 'Ohne Zugriff auf die Kamera können keine eigenen Aufgaben mit Fotos erstellt werden.'
    },

    global: {
        missingImage: 'Bild lädt...',
        ok: 'OK',
        delete: 'Löschen',
        new: 'Neu: ',
        question: 'Frage: ',
        info: 'Hinweis',
        warning: 'Achtung',
        error: 'Fehler',
        mediaSize: 'Die Mediendatei ist mit %{size} MB zu groß für die InA.Coach App. Bitte %{max} MB nicht überschreiten.',
        mediaPickError: 'Die Mediendatei konnte nicht verarbeitet werden - möglicherweise ist sie zu groß.',
        mediaStoreError: 'Die Mediendatei konnte nicht verarbeitet werden - möglicherweise ist sie zu groß %{size} MB.',
        mediaUpload: 'Die Mediendatei konnte nicht verarbeitet werden: %{error}',
        inValidQRCode: 'Der gescannte QR-Code ist kein InA.Coach QR-Code.',
        wrongQRCode: 'Der gescannte QR-Code ist hier nicht gültig.',
        ownQRCode: 'Der gescannte QR-Code ist Ihre eigene ID. Diese können Sie hier nicht verwenden.',
        ownMail: 'Die eingegebene E-Mail-Adresse ist Ihre eigene. Diese können Sie hier nicht verwenden.',
        updateAvailable: 'Die InA.Coach App wird gerade aktualisiert.',
        noUpdateAvailable: 'Sie verwenden die aktuelle Version der InA.Coach App.',
        errorUpdate: 'Im Moment ist kein Update der InA.Coach App möglich.'
    },

    message: {
        info: 'Hinweis',
        warning: 'Warnung',
        error: 'Fehler',
        back: 'OK',
        nologin: 'Ein falscher User oder ein falsches Passwort wurden eingegeben.',
        notAuth: 'User nicht authorisiert, bitte erneut anmelden.',
        timerDone: 'Timer abgelaufen',
        notifyOld: 'Benachrichtigung überholt',
        backToTask: 'Zurück zur Aufgabe',
        showStep: 'Schritt %{idx}: %{title}',
        cancel: 'Abbrechen',
        continueTask: 'Wollen Sie mit Ihrer Aufgabe fortfahren?',
        serverError: 'Der InA.Coach Server hat die Bearbeitung abgebrochen.',
        imageError: 'Die Mediendatei %{image} ist nicht vorhanden.',
        uploadError: 'Die Mediendatei konnte nicht auf den Server geladen werden (%{error}).',
        internalError: 'Bei der Bearbeitung ist ein Fehler aufgetreten (%{error}).',
        notFound: 'Eine Aufgabe mit dem Titel "%{title}" wurde nicht gefunden.',
        linkedTask: 'Verknüpfte Aufgabe',
    },

    notify: {
        title: 'InA.Coach Benachrichtigung 📫',
        news: 'Es gibt Neuigkeiten für Sie.',
        timer: 'Die Wartezeit im Schritt %{idx} der Aufgabe "%{title}" ist beendet.',
        noToken: 'Push Benachrichtigungen nicht möglich.'
    },

    report: {
        title: 'Melden',
        send: 'Senden',
        reason: 'Warum melden Sie diese Aufgabe?',
        type: 'Grund',
        cancel: 'Abbrechen',
        hate: 'Hass/Hetze',
        trademark_violation: 'Urheberrechtsverletzung',
        harassment: 'Beleidigung/Diskriminierung',
        drug_consumtion: 'Alkohol-/Drogenkonsum',
        pornografic_material: 'Sexueller/Pornographischer Inhalt ',
        violence: 'Gewaltdarstellung',
        gambling: 'Glücksspiel/Wetten',
        other: 'Sonstiger Grund',
        description: 'Beschreibung'
    },

    support: {
        title: 'Support Anfrage',
        send: 'Senden',
        reason: 'Warum schicken Sie diesen Screenshot?',
        cancel: 'Abbrechen',
        description: 'Beschreibung'
    },

    blank: {
        title: 'Baustelle',
        info: 'Das ist in Vorbereitung...',
    },

    blocked: {
        title: 'Der Beta-Test ist beendet!',
        info: `Liebe Nutzer:innen,
vielen Dank, dass Sie uns geholfen haben, neue InA.Coach Funktionen vorab zu testen!
Diese Test App hat jetzt allerdings ausgedient und wurde von der offiziellen InA.Coach App Version 2 in den App Stores abgelöst.
Wenn Sie die App dort aktualisieren, haben Sie die neueste offizielle Version und können wieder ganz normal auf Ihren Account und alle Ihre Daten zugreifen - inklusive vieler neuer Funktionen.`,
        closing: 'Bis bald,\nIhr InA.Coach Entwicker-Team',
    },

    imprint: {
        header: 'Impressum',
    },

    osl: {
        header: 'Open Source Lizenzen'
    },

    dpa: {
        header: 'Datenschutzerklärung',
        info: 'Bitte lesen und ganz unten zustimmen.',
        accept: 'Zustimmen'
    },

    tou: {
        header: 'Nutzungsvereinbarung',
        info: 'Bitte lesen und ganz unten zustimmen.',
        accept: 'Zustimmen',
    },

    drawing: {
        rect: 'Rechteck',
        circle: 'Kreis',
        ellipse: 'Ellipse',
        path: 'Pfad',
        line: 'Linie',
        'apple-keyboard-shift': 'mit Umschalttaste',
        'cursor-move': 'Schieben',
        'rotate-left': 'Drehen',
        delete: 'Löschen',
        arrow: 'Pfeil',
        color: 'Farbe',
        weight: 'Dicke',
        none: 'Transparent',
        color0: 'Dunkelrot',
        color1: 'Hellrot',
        color2: 'Dunkelgrün',
        color3: 'Hellgrün',
        color4: 'Dunkelblau',
        color5: 'Hellblau',
        color6: 'Dunkelgelb',
        color7: 'Hellgelb',
        color8: 'Orange',
        color9: 'Rosa',
        color10: 'Grau',
        color11: 'Schwarz',
        color12: 'Weiß',
        color13: 'Transparent',
    },

    studio: {
        main: {
            title: 'InA.Studio',
            info: 'Hauptmenü',
            myWorkflows: 'Meine Aufgaben',
            emptyWorkflow: 'Leere Aufgabe',
            noTitle: 'Aufgabe ohne Titel',
            noText: 'Aufgabe ohne Beschreibung',
            welcomeHeader: 'Herzlich willkommen %{name} im InA.Studio!',
            welcomeMessage: 'InA.Studio ist ab sofort Ihr kreatives Zuhause für die bequeme Erstellung von InA.Coach Aufgaben.\n' +
                'Erstellen Sie im Handumdrehen Aufgaben im Editor und führen Sie diese dann mit der gewohnten Leichtigkeit in der InA.Coach App aus.\n\n' +
                'Falls Sie die App noch nicht nutzen, laden Sie sie jetzt herunter, um Ihre Aufgaben am Mobilgerät durchzuführen.\n\n' +
                'Bitte beachten Sie, dass Sie die erste Version (Beta-Version) des InA.Studios nutzen und dass Sie mit Ihrem Feedback einen wertvollen Beitrag zur Weiterentwicklung leisten können. Helfen Sie uns bitte dabei, das InA.Studio zu optimieren und genau auf Ihre Bedürfnisse zuzuschneiden. Wir freuen uns auf Ihr Engagement und Ihre Rückmeldungen.\n\n' +
                'Zukünftig werden Ihnen hier noch weitere – bekannte und neue – Funktionen zur Verfügung stehen!\n' +
                'Sie dürfen also gespannt sein.\n\n' +
                'Vielen Dank, dass Sie Teil der InA.Community sind und uns auf dieser Reise begleiten!',
            dontShow: 'Nicht mehr anzeigen',
            show: 'Anzeigen',
        },
        market: {
            marketplace: 'Marktplatz',
            giftTitle: 'Aufgabe verschenken',
            giftTaken: 'Aufgabe mitgenommen',
            giftTakenAt: '*Mitgenommen am %{date}',
            giftInfo: 'Wählen Sie aus, welche Aufgabe Sie auf den Marktplatz stellen möchten.\nAufgaben können verschenkt werden, wenn sie mindestens 2 Schritte haben und ohne Fehler exportierbar sind.',
            giftSend: 'Verschenken',
            giftTake: 'Mitnehmen',
            giftTaskHeader: 'Aufgabe',
            giftTextHeader: 'Beschreibung',
            giftProfileHeader: 'Profile',
            giftCategoryHeader: 'Kategorie',
            info: 'Info',
            remove: 'Entfernen'
        },
        sideNavigationBar: {
            home: 'Aufgabenliste',
            editor: 'Editor',
            contacts: 'Kontakte',
            channels: 'Kanäle',
            planner: 'Planer',
            community: 'Community',
            statistics: 'Auswertung',
            admin: 'Administration'
        },
        channel: {
            title: 'Kanal Übersicht - InA.Studio',
            exit: 'Kanal verlassen',
            membersN: '%{num} Kontakte',
            channelWorkflows: 'Aufgaben im Kanal',
            sharedFromChannelToContactN: 'Von "%{channel}" an Empfänger geteilt (%{num})',
        },
        contact: {
            title: 'Kontakt Übersicht - InA.Studio',
            exit: 'Kontakt verlassen',
            sharedWorkflows: 'Geteilte Aufgaben',
            sharedFromMeToContactN: 'An "%{contact}" von dir (%{num})',
            sharedFromContactToMeN: 'Von "%{contact}" an dich (%{num})',
            contactAddedTochannelByMeN: 'Kanäle für "%{contact}" (%{num})',
            contactChannelsFor: 'Kanäle für "%{contact}" verwalten',
        },
        editor: {
            title: 'InA.Studio',
            info: 'Editor',
            exit: 'Editor verlassen',
            savingAlert: 'Änderungen verwerfen?\nSie haben Änderungen, die nicht gespeichert werden konnten. Sind Sie sicher, dass Sie den Editor verlassen möchten und somit die Änderungen verwerfen?',
            addMedia: 'Medien hinzufügen',
            zoomIn: 'Zoom vergrößern',
            zoomOut: 'Zoom verkleinern',
            fitView: 'Anzeige anpassen',
            autoLayout: 'Auto-Layout',
            lock: 'Bearbeitung sperren',
            copied: 'Aufgabe dupliziert',
        },
        flow: {
            undo: 'Rückgängig',
            redo: 'Wiederherstellen',
            validation: 'Überprüfen',
            export: 'Exportieren',
            exportSuccess: 'Der Export war erfolgreich.',
            exportSuccessMessage: 'Die Aufgabe “%{title}” ist jetzt in Ihrer InA.Coach App verfügbar.\nSie müssen die Aufgabenliste in der App aktualisieren, um die Aufgabe sichtbar zu machen.',
            exportFail: 'Der Export war nicht erfolgreich!',
            exportFailMessage: 'Die Aufgabe konnte nicht exportiert werden! Versuchen Sie es später erneut.',
            importHello: 'Hallo!',
            importMessage: 'Sie möchten die InA.Coach App Aufgabe “%{title}” im InA.Studio öffnen.\nAktuell ist das Bearbeiten von Aufgaben entweder im Studio ODER in der mobilen App möglich. Sie können entscheiden, ob Sie das Bearbeitungsrecht der App an das Studio abgeben.\n\n\nHinweis: Diese Einstellung kann nicht rückgängig gemacht werden.',
            watch: 'Nur anschauen',
            convertToStudioWorkflow: 'Im Studio bearbeiten',
            aiSupport: "KI-Unterstützung (Beta)",
            aiFinish: "KI-Unterstützung (Beta) beenden",
            aiErrorWarning: "*Die KI kann Fehler machen. Überprüfen Sie wichtige Informationen.",
            aiEdit: "Prompt bearbeiten",
            aiOk: "Speichern",
            aiCancel: "Abbrechen",
            aiInvalidJSON: "Der geänderte Prompt muss ein gültiges JSON-Format haben: %{error}",
            aiFormatJSON: "Dieser Prompt ist im JSON Format:",
            aiFormatText: "Dieser Prompt ist im Text Format:",
            simulator: 'Simulator',
            openSimulator: 'Simulator öffnen',
        },
        issue: {
            workflowValid: 'Die Aufgabe kann exportiert werden.',
            workflowInvalid: 'Folgende Verknüpfungen sind noch fehlerhaft!',
            exportSuccess: 'Erfolgreich exportiert',
            exportFail: 'Kein Export',
            invalidStart: 'Ungültiger Start',
            invalidStartText: 'Es gibt keine durchgängige Verbindung vom Start- zum Ende-Element.',
            invalidEnd: 'Ungültiges Ende',
            invalidEndText: 'Es gibt keine durchgängige Verbindung vom Start- zum Ende-Element.',
            noValidWay: 'Verbindung fehlt',
            noValidWayText: 'Es gibt keine durchgängige Verbindung vom Start- zum Ende-Element.',
            deadEnd: 'Sackgasse',
            deadEndText: 'Ein Schritt-Element hat keine Verbindung zu einem weiteren Schritt- oder dem Ende-Element.',
            noIncomer: 'Unerreichbares Schritt-Element',
            noIncomerText: 'Ein Schritt-Element ist in der Schrittfolge nicht erreichbar.',
            badCycle: 'Endlosschleife',
            badCycleText: 'Schritt-Elemente sind zu einer Endlosschleife verbunden.',
            nodeUnreachable: 'Unerreichbares Schritt-Element',
            nodeUnreachableText: 'Ein Schritt-Element ist in der Schrittfolge nicht erreichbar.',
            looseConstruct: 'Loses Schritt-Element',
            looseConstructText: 'Es gibt ein Schritt-Element, das keine Verbindung zur restlichen Schrittfolge hat, die bereits mit dem Start- und Ende-Element verbunden ist.',
            redundancy: 'Gleiche Antwort',
            redundancyText: 'Im Entscheidungs-Element führen beide Antworten zum gleichen Schritt- oder zum Ende-Element.',
            noTitle: 'Kein Titel',
            noTitleText: 'Die Aufgabe hat keinen Titel.',
        },

        itemInput: {
            title: 'Aufgabentitel',
            text: 'Beschreibung der Aufgabe',
        },
    },
    modalFcm: {
        contactRequest: 'Sie haben eine neue Kontaktanfrage!',
        plannerEvent: 'Eine geplante Aufgabe ist fällig!',
        newShare: 'Ihnen wurde eine neue Aufgabe geteilt!',
        newCopy: 'Sie haben die Kopie einer Aufgabe erhalten!',
        plannerRequest: 'Sie haben eine neue Planer-Anfrage!',
        goToContacts: 'Kontakte anzeigen',
        goToPlannerRequests: 'Planer-Anfrage anzeigen',
        goToWorkflow: 'Aufgabe anzeigen'
    },
    plannerMessage: {
        title: 'Eine Aufgabe ist fällig',
        body: 'Klicken Sie hier, um die Aufgabe anzuschauen',
    },
    plannerRequest: {
        request: "Anfrage",
        send: "Senden",
        title: "Planungsanfragen",
        sendRequest: "Anfrage senden",
        requestFrom: "Von (%{num})",
        requestTo: "An (%{num})",
        plannerRequests: "Anfragen",
        contactsLeft: "Offene Kontakte (%{num})"
    },
}
